export default "__VITE_ASSET__zGiFsG9Z__"